"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "priverno": {
    "e88f10ae": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "skipSearch": false
    }],
    "boschetto": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "861ddb4f": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "skipSearch": false
    }],
    "le-crete": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "806e9366": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "skipSearch": false
    }],
    "osteria-dei-pignatari": [{
      "hkey": "3463d1ba",
      "slug": "priverno",
      "name": "Priverno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;